<template>
  <svg width="20" height="20" viewBox="0 0 20 20">
    <path
      d="m10.009 11.309 5.017-4.945a.94.94 0 0 1 1.319 0 .923.923 0 0 1 .01 1.305l-5.02 4.947-1.326 1.313-1.332-1.308-5.03-4.963a.925.925 0 0 1-.01-1.307.944.944 0 0 1 1.331-.01l5.04 4.968z"
      fill="#737380"
      fill-rule="evenodd"
    />
  </svg>
</template>
